import { useRouter } from "next/router"
import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import FeedbackMessage from "~/components/molecules/FeedbackMessage"
import { Color, IsMobile, SpacingSize } from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

interface FormProps {
  complete: boolean
}

export const Form = ({ complete }: FormProps) => {
  const router = useRouter()
  let iframeSrc = ""

  switch (router.query.source) {
    case "facebook":
      iframeSrc = "https://info.legaseed.co.jp/l/736943/2022-05-24/2n22yg"
      break
    case "listing":
      iframeSrc = "https://info.legaseed.co.jp/l/736943/2022-05-20/2l45vc"
      break
    default:
      iframeSrc = "https://info.legaseed.co.jp/l/736943/2022-04-11/24vl4h"
  }

  return (
    <FormContainer id="form" complete={complete}>
      <Container size="Large" className="section-container">
        <Typography type="SubHero" className="form-content_heading">
          資料請求・お問い合わせ
        </Typography>
        <div className="form-content_group">
          <p>新規お問い合わせの受付を一時停止しております。</p>
          {/* {complete && (
            <FeedbackMessage
              type="secondary"
              messages={["お問い合わせが完了しました。1営業日以内に担当よりご連絡いたします。"]}
              className="submit-complete-message"
            />
          )}
          <div className="form-appeal-container">
            <div className="form-appeal-heading">
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/form-appeal-light.svg")}
                className="form-appeal-heading-icon"
                alt=""
              />
              こんなことが分かります
            </div>
            <div className="form-appeal-features">
              <div className="form-appeal-feature-item">
                詳しい学生の
                <br />
                データベース
              </div>
              <div className="form-appeal-feature-item">料金プラン</div>
              <div className="form-appeal-feature-item">サービス</div>
              <div className="form-appeal-feature-item">詳しい機能</div>
            </div>
            <img
              src={staticPath("/static/images/new-grad-scout/corp-contact/release-campaign-banner.png")}
              className="form-appeal-campaign-banner"
              alt="スカウトの返信率を劇的に高める3つの要素を無料配布中"
            />
          </div>
          <div className="form-content_item">
            <Pc>
              <iframe
                src={iframeSrc}
                width="100%"
                height="1000"
                // @ts-ignore: Camel Case にすると React の警告が出るため
                allowtransparency="true"
                style={{ border: 0 }}
              ></iframe>
            </Pc>
            <Sp>
              <iframe
                src={iframeSrc}
                width="100%"
                height="1000"
                // @ts-ignore
                allowtransparency="true"
                style={{ border: 0 }}
              ></iframe>
            </Sp>
          </div> */}
        </div>
      </Container>
    </FormContainer>
  )
}

const FormContainer = styled.div<Pick<FormProps, "complete">>`
  background: ${Color.BackgroundPrimary};
  padding: 96px 0;
  ${IsMobile(css`
    padding: 80px 0;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .form-content_heading {
    margin-bottom: ${SpacingSize["4XL"]}px;
    text-align: center;
    ${IsMobile(css`
      font-size: 20px;
    `)}
    &:after {
      display: block;
      content: "";
      height: 3px;
      width: 60px;
      background: ${Color.Primary};
      border-radius: 3px;
      margin: ${SpacingSize.M}px auto;
    }
  }
  .form-content_group {
    max-width: 640px;
    margin: auto;
    background: ${Color.White};
    padding: ${SpacingSize["2XL"]}px;
    ${IsMobile(css`
      padding: 24px 12px;
    `)}
  }
  .submit-complete-message {
    ${IsMobile(css`
      margin: 0 8px 8px;
    `)}
  }
  .form-appeal-heading {
    position: relative;
    height: 40px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: ${Color.White};
    background-color: ${Color.Primary};
    ${IsMobile(css`
      font-size: 16px;
    `)}
    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      left: 66px;
      bottom: -12px;
      border-top: 12px solid ${Color.Primary};
      border-left: 12px solid transparent;
    }
  }
  .form-appeal-heading-icon {
    margin-right: 10px;
  }
  .form-appeal-features {
    margin-bottom: 28px;
    display: flex;
    justify-content: center;
    ${IsMobile(css`
      margin-bottom: 20px;
    `)}
  }
  .form-appeal-feature-item {
    position: relative;
    width: 140px;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: ${Color.Primary};
    border: 1px solid ${Color.Primary};
    border-radius: 50%;
    ${IsMobile(css`
      width: 86px;
      height: 86px;
      font-size: 10px;
    `)}
    &:nth-child(1) {
      left: 15px;
    }
    &:nth-child(2) {
      left: 5px;
    }
    &:nth-child(3) {
      right: 5px;
    }
    &:nth-child(4) {
      right: 15px;
    }
  }
  .form-appeal-campaign-banner {
    width: 572px;
    margin: 0 auto;
    ${IsMobile(css`
      width: 100%;
    `)}
  }
  .form-content_item {
    margin-bottom: ${SpacingSize.XL}px;
    ${({ complete }) =>
      complete &&
      css`
        opacity: 0.2;
      `}
  }
  .form-content_button {
    max-width: 260px;
    margin: auto;
  }
`
